import { t } from 'i18next';
import React, { useEffect, useState } from 'react'
import PermanentBookingFileDropDown from './PermanentBookingFileDropDown'
import PermanentBookingItem from './PermanentBookingItem'
import { Divider } from '../../common/Divider';
import { Alert } from '../../common/Alert'
import { CommonFilter } from '../../common/CommonFilter/CommonFilter';

const PermanentBookingList = React.forwardRef(({
    fileList,
    flag,
    setListPageOpen,
    fileName,
    setFileName,
    bookingList,
    setBookingList,
    setRequest,
    setEditButtonActive,
    isEditButtonActive,
    clearToken,
    isRefreshActive,
    isMassUpload
}, ref) => {


    const [bookingFilter, setBookingFilter] = useState({
        confirmed: true,
        queued: true,
        tobeProcessed: true,
        failed: true,
    })

    const [temporaryBookingFilter, setTemporaryBookingFilter] = useState({
        confirmed: true,
        queued: true,
        tobeProcessed: true,
        failed: true,
    })

    const [sortedArray, setSortedArray] = useState([])
    const [alertMessage, setAlertMessage] = useState('')
    const [status, setStatus] = useState(null)

    useEffect(() => {
        if (bookingList && bookingList?.bookingList?.length) {
            sortArrayFun(bookingList)
        }
    }, [bookingList])

    // sort array based on date function
    const sortArrayFun = (bookingList) => {
        const reqarray = bookingList?.bookingList.map((item) => {
            JSON.parse(item.requestParameters)
            return item
        })


        const arraySorted = reqarray?.sort((a, b) => {

            const aValue = JSON.parse(a?.requestParameters)
            const bValue = JSON.parse(b?.requestParameters)

            const dateA = aValue?.shipmentDetails?.shippingDate ? new Date(aValue?.shipmentDetails?.shippingDate.split('-').reverse().join(' ')) : new Date();
            const dateB = bValue?.shipmentDetails?.shippingDate ? new Date(bValue?.shipmentDetails?.shippingDate.split('-').reverse().join(' ')) : new Date();
            return dateA - dateB;
        })
        setSortedArray(arraySorted)

    }

    const handleAlertClose = () => {
        setStatus(null)
        setAlertMessage('')
    }

    const dropDownChangeHandler = () => {
        setTemporaryBookingFilter({
            confirmed: true,
            queued: true,
            tobeProcessed: true,
            failed: true,
        })
    }

    const applyFilterClickHandler = () => {
        setBookingFilter(temporaryBookingFilter)
    }

    const resetFilterClickHandler = () => {
        setTemporaryBookingFilter({
            confirmed: true,
            queued: true,
            tobeProcessed: true,
            failed: true,
        })
    }

    return (
        <>
            {alertMessage !== '' && status !== null && (
                <Alert
                    isError={!status}
                    showAlert={true}
                    message={t(alertMessage, { ns: 'errors' })}
                    setTimeout={true}
                    onAlertClose={handleAlertClose}
                />
            )}
            <div className='mutliple-booking-header-row'>
                <PermanentBookingFileDropDown
                    fileList={fileList}
                    setFileName={setFileName}
                    bookingFilter={bookingFilter}
                    setListPageOpen={setListPageOpen}
                    fileName={fileName}
                    clearToken={clearToken}
                    isRefreshActive={isRefreshActive}
                    dropDownChangeHandler={dropDownChangeHandler}
                />
                {(bookingList?.bookingList?.length !== 0) ?
                    <CommonFilter
                        panelWidth='361px'
                        filterDetailsArray={[
                            {
                                label: 'COMMON.CONFIRMED',
                                isChecked: temporaryBookingFilter?.confirmed,
                                onChange: (e) => setTemporaryBookingFilter({ ...temporaryBookingFilter, confirmed: e.target.checked })
                            },
                            {
                                label: 'COMMON.QUEUED',
                                isChecked: temporaryBookingFilter?.queued,
                                onChange: (e) => setTemporaryBookingFilter({ ...temporaryBookingFilter, queued: e.target.checked })
                            },
                            {
                                label: 'EXTRAS.TO_BE_PROCESSED',
                                isChecked: temporaryBookingFilter?.tobeProcessed,
                                onChange: (e) => setTemporaryBookingFilter({ ...temporaryBookingFilter, tobeProcessed: e.target.checked })
                            },
                            {
                                label: 'EXTRAS.FAILED',
                                isChecked: temporaryBookingFilter?.failed,
                                onChange: (e) => setTemporaryBookingFilter({ ...temporaryBookingFilter, failed: e.target.checked })
                            }
                        ]}
                        className='ml-auto'
                        applyFilterClick={applyFilterClickHandler}
                        resetFilterClick={resetFilterClickHandler}
                        filterHeader={t("COMMON.FILTER_BY_STATUS")}
                    /> : <></>
                }
            </div>

            {
                (bookingList?.bookingList) ?
                    <div className='common-list-table-scroll'>
                        <table class="common-list-table" ref={ref}>
                            <tr className='table-header'>
                                <th className="header-cell">{t('COMMON.ORG')}-{t('COMMON.DEST')}</th>
                                <th className="header-cell">{t('COMMON.SHIPMENT_INFO')}</th>
                                <th className="header-cell">{t('COMMON.SHP_DATE')}</th>
                                <th className="header-cell">{t('PERMANENT_BOOKING.RATE_TYPE')}</th>
                                <th className="header-cell">{t('PERMANENT_BOOKING.RATE_PER_KG')}</th>
                                <th className="header-cell">{t('PERMANENT_BOOKING.AWB')}</th>
                                <th className="header-cell">{t('COMMON.STATUS')}</th>
                                <th className="header-cell"></th>
                            </tr>
                            <Divider />
                            <tbody className='table-body'>
                                {
                                    bookingList?.bookingList?.length !== 0 ?
                                        (
                                            sortedArray
                                                .map((bookingItem, index) => (
                                                    <PermanentBookingItem
                                                        flag={flag}
                                                        key={index}
                                                        index={index}
                                                        bookingItem={bookingItem}
                                                        fileName={fileName}
                                                        bookingFilter={bookingFilter}
                                                        setBookingList={setBookingList}
                                                        setAutoRefresh={setRequest}
                                                        setEditButtonActive={setEditButtonActive}
                                                        isEditButtonActive={isEditButtonActive}
                                                        clearToken={clearToken}
                                                        setAlertMessage={setAlertMessage}
                                                        setStatus={setStatus}
                                                        isMassUpload={isMassUpload}
                                                    />
                                                ))
                                        ) :
                                        (
                                            <label className='no-data-avilable'>{t('PERMANENT_BOOKING.NO_DATA')}</label>
                                        )
                                }
                            </tbody>
                        </table>
                    </div> : <></>
            }
        </>)
})

export default PermanentBookingList